import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import startAccount from './modules/startAccount'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
        startAccount,
    },
})

export default _store
